import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-grid-system';
import { TennisDayWrapper } from './styles';
import HeaderTable from '../../../components/HeaderTable';
import TennisTable from '../TennisTable';

class TennisDay extends Component {
  formatDate = (date) => {
    const options = {
      weekday: 'long', month: 'long', day: '2-digit', timeZone: 'UTC',
    };
    return new Date(date).toLocaleString('it-IT', options);
  };

  render() {
    const {
      tennisMatches, isMobile, tournament, competitionId,
    } = this.props;
    return (
      <TennisDayWrapper>
        {tennisMatches && tennisMatches.get('match') &&
        tennisMatches.get('match').map((round, index) => (
          <Row
            style={{
              marginLeft: 0,
              marginRight: 0,
              marginBottom: '40px',
            }}
            key={index}
          >
            <Col
              md={12}
              sm={12}
              xs={12}
              style={{
                paddingLeft: 0,
                paddingRight: 0,
              }}
            >
              <HeaderTable
                title={this.formatDate(round.keySeq().toArray()[0])}
                bgColor="tableHeaderColor"
              />
            </Col>
            <TennisTable
              matches={round.get(round.keySeq().toArray()[0])}
              isMobile={isMobile}
              tournament={tournament}
              competitionId={competitionId}
            />
          </Row>
        ))
        }
      </TennisDayWrapper>
    );
  }
}

TennisDay.propTypes = {
  tennisMatches: PropTypes.any,
  isMobile: PropTypes.bool,
  tournament: PropTypes.any,
  competitionId: PropTypes.any,
};

export default TennisDay;



// WEBPACK FOOTER //
// ./src/containers/TennisCalendar/TennisDay/index.js